import { Row, Col } from 'react-bootstrap';
import VerantIdBorderSmall from "../../../images/VerantId/verant_id_border_small.png";
import VerantSmallLogo from "../../../images/VerantId/verant_small_logo.svg";
import VerantSmallImages from "../../../images/VerantId/verant_small_images.svg";
import VerantMediumImages from "../../../images/VerantId/verant_medium_images.svg";
import AiComparisonCloudMedium from "../../../images/VerantId/ai_comparison_cloud_medium.svg";
import DmvDatabaseCloudMedium from "../../../images/VerantId/dmv_database_cloud_medium.svg";

const VerantId = () => {

    return (
        <>
            <img 
                src={VerantIdBorderSmall} 
                className="verantIdBorderTop"
                alt="verant id border small"
            />
            <Row>
                <Col lg="5" className="verantTextCol">
                    <div className="modalTextLeft verantScrolling">
                        <h3 className="modalHeader">ID VERIFICATION</h3>
                        <div className="verantMobileLogo">
                            <img src={VerantSmallLogo} className="verantSmallLogo" alt="verant small logo" />
                        </div>
                        <p className="modalSubHeader">CHALLENGE</p>
                        <p>
                           Clients needed a simple, secure way to verify customer identities online—without forcing an additional software. The solution had to support two verification options (selfie-to-ID face match and DMV record check), and plug into the existing WordPress client portal, and preserve an auditable history of past verifications.
                        </p>
                        <p className="modalSubHeader">APPROACH</p>
                        <p>
                            We designed a guided, browser-based experience with two paths:
                            <ul className="verantList">
                                <li><strong style={{fontWeight: "bold"}}>Face Verification:</strong> Capture front/back of an ID, take a selfie, and receive an immediate similarity result.</li>
                                <li><strong style={{fontWeight: "bold"}}>DMV Verification:</strong> Collect and validate license details against DMV records to flag any mismatches.</li>
                            </ul>
                            Both paths share a consistent UI for clarity, run behind portal authentication, and respect client-level permissions. Results are stored with timestamps and status, so authorized users can review outcomes, see mismatch reasons at a glance, and reference a verification history for each user.
                        </p>
                        <p className="modalSubHeader">RESULTS</p>
                        <p>
                            A flexible, app-free verification flow that reduces friction for end users and overhead for staff. Teams choose the path that fits their risk profile—Face, DMV, or both—while the portal centralizes results and history in one place. 
                        </p>
                        <p>
                            The outcome: faster decisions, fewer support loops, and a clear audit trail for compliance.
                        </p>
                    </div>
                    
                    {/* Mobile Images */}
                    <div className="verantMobileImages">
                        <img src={VerantSmallImages} className="verantSmallImagesImg" alt="verant small images" />
                        <img src={DmvDatabaseCloudMedium} className="dmvCloudMobile" alt="dmv database cloud" />
                        <img src={AiComparisonCloudMedium} className="aiCloudMobile" alt="ai comparison cloud" />
                    </div>
                    
                    {/* Tablet Images */}
                    <div className="verantTabletImages">
                        <img src={VerantMediumImages} className="verantMediumImagesImg" alt="verant medium images" />
                        <img src={DmvDatabaseCloudMedium} className="dmvCloudTablet" alt="dmv database cloud" />
                        <img src={AiComparisonCloudMedium} className="aiCloudTablet" alt="ai comparison cloud" />
                    </div>
                </Col>
                <Col lg="6">
                </Col>
            </Row>
        </>
    );
};

export default VerantId;